export const FailIcon = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="1em" height="1em" fill="none" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M37.5664 19.0166V21.3499"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="6.59966"
      />
      <path
        d="M18.4336 19.0166V21.3499"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="6.59966"
      />
      <path
        d="M37.8002 38.0336C37.8002 38.0336 35.0002 32.4336 28.0002 32.4336C21.0002 32.4336 18.2002 38.0336 18.2002 38.0336"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.5"
      />
    </svg>
  );
};
